const preloadImages = (imageArray) => {
  imageArray.forEach((src) => {
    const img = new window.Image();
    img.onload = () => {
      console.log(`preloaded: ${src}`);
    };
    img.onerror = () => {
      console.error(`failed to preload: ${src}`);
    };
    img.src = src;
  });
};

export default preloadImages;
